import React, { useEffect } from 'react';
import { setPageTitle } from '../../utils/title';
import Breadcrumb from '../../components/Breadcrumb';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  useEffect(() => {
    setPageTitle('Privacy Policy');
  }, []);

  const breadcrumbItems = [
    { path: '/', label: 'Home' },
    { path: '/privacy-policy', label: 'Privacy Policy' },
  ];

  return (
    <div className="privacy-policy-page">
      <Breadcrumb items={breadcrumbItems} />
      <section className="page-header">
        <div className="container">
          <h1 className="page-header__title">Privacy Policy</h1>
          <p className="page-header__subtitle">How we collect, use, and protect your information</p>
        </div>
      </section>

      <section className="privacy-policy-content section section--light">
        <div className="container">
          <div className="content-wrapper">
            <p className="policy-intro">
              This Privacy Policy describes how DevSecOps, Inc. ("we," "our," or "us") collects,
              uses, and protects the personal information you provide on our website
              www.devsecopsinc.io (the "Website"). This policy applies to all visitors, users, and
              customers of our Website and cloud security, DevSecOps, and GRC program implementation
              services.
            </p>

            <p className="policy-intro">
              By using our Website, you agree to the collection and use of information in accordance
              with this Privacy Policy. If you do not agree with any part of this policy, please do
              not use our Website or submit any personal information to us.
            </p>

            <h2>Information We Collect</h2>
            <p>
              We collect information from you when you interact with our website in the following
              ways:
            </p>

            <h3>Newsletter Subscription</h3>
            <p>When you subscribe to our newsletter, we collect:</p>
            <ul>
              <li>Full Name</li>
              <li>Email Address</li>
            </ul>

            <h3>Contact Us Form</h3>
            <p>When you submit our contact form, we collect:</p>
            <ul>
              <li>Full Name</li>
              <li>Email Address</li>
              <li>Company Name</li>
              <li>Subject</li>
              <li>Message Content</li>
            </ul>

            <h3>California Privacy Rights (CCPA/CPRA)</h3>
            <p>When you submit a "Do Not Sell My Personal Information" request, we collect:</p>
            <ul>
              <li>Full Name</li>
              <li>Email Address</li>
              <li>California Address</li>
              <li>Phone Number (optional)</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We use the information we collect exclusively for the following purposes:</p>
            <ul>
              <li>To respond to your inquiries and contact requests</li>
              <li>To send newsletters and updates you've subscribed to</li>
              <li>To process and respond to your privacy rights requests</li>
              <li>To improve our website and services</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2>Information Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or otherwise transfer your personal information to third
              parties. Your information is only used internally for the purposes described above.
            </p>

            <h2>Cookie Policy</h2>
            <p>
              Our website uses cookies and similar tracking technologies to enhance your browsing
              experience and analyze website traffic. We implement a cookie consent mechanism that:
            </p>
            <ul>
              <li>Requires explicit consent before setting any non-essential cookies</li>
              <li>
                Uses Google Analytics with privacy-focused settings:
                <ul>
                  <li>IP anonymization enabled</li>
                  <li>Data sharing with Google disabled</li>
                  <li>Advertising features disabled</li>
                  <li>User-ID tracking disabled</li>
                </ul>
              </li>
              <li>Allows you to withdraw consent at any time</li>
            </ul>

            <h3>Types of Cookies We Use</h3>
            <ul>
              <li>
                <strong>Essential Cookies:</strong> Required for basic website functionality
              </li>
              <li>
                <strong>Analytics Cookies:</strong> Help us understand how visitors interact with
                our website (only set with your consent)
              </li>
            </ul>

            <h2>Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect
              your personal information against unauthorized access, alteration, disclosure, or
              destruction. These measures comply with HIPAA and SOC 2 requirements.
            </p>

            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for data processing</li>
              <li>Object to processing of your information</li>
              <li>Request restriction of processing</li>
              <li>Data portability</li>
            </ul>

            <h2>California Residents' Rights</h2>
            <p>
              Under the California Consumer Privacy Act (CCPA) and the California Privacy Rights Act
              (CPRA), California residents have additional rights regarding their personal
              information. You can exercise these rights by submitting a "Do Not Sell My Personal
              Information" request through our website.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or would like to exercise your
              privacy rights, please contact us through our Contact Us form or submit a CCPA/CPRA
              request if you are a California resident.
            </p>

            <h2>Updates to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The latest version will always be
              posted on this page with the effective date.
            </p>

            <p className="last-updated">Last Updated: April 11, 2025</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
